import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { SlButton, SlDrawer, SlTooltip, SlOption, SlSelect, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import { useDispatch } from 'react-redux';
import api from "../../services/api"
import { Toast } from '../../shared/Toast'
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { roles } from "../../utils/constants";
import { useFormik } from "formik";

const initialPrices = {
    ad_amount: '',
    premium_amount: '',
    location: ''
}

let initialValues = JSON.parse(JSON.stringify(initialPrices));


export const campCreativeContext = React.createContext();
function AdsPrices() {
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [flag, setFlag] = useState('')
    const [submit, setSubmit] = useState(false);
    const [show, setShow] = useState(false);

    const [languages, setLanguages] = useState([]);
    const [languageSelected, setLanguageSelected] = useState(1);
    const [districts, setDistricts] = useState([]);
    const [districtSelected, setDistrictSelected] = useState("0");
    const [data, setData] = useState([])
    const [langId, setLangId] = useState(0);
    const [distId, setDistId] = useState(0);
    const [mandalId, setMandalId] = useState(0);



    const getLanguages = async () => {
        if (localStorage.getItem("role") === roles.ops) {
            setLoader(true);
            const response = await api({
                url: `/ads_price_location/getLanguages`,
                method: "POST",
                responseType: "json",
            });
            setLanguages(response.data.data);
            setLoader(false);
        }
    };
    const getDistricts = async (languageSelected) => {
        if (localStorage.getItem("role") === roles.ops) {
            setLoader(true);
            const response = await api({
                url: `/ads_price_location/getDistricts`,
                method: "POST",
                responseType: "json",
                data: {
                    lang_id: parseInt(languageSelected)
                }
            });
            setDistricts(response.data.data);
            setLoader(false);
        }
    }

    const getAdsAmounts = async (languageSelected, districtSelected) => {
        if (localStorage.getItem("role") === roles.ops) {
            setLoader(true);
            const response = await api({
                url: `/ads_price_location/getAdsAmounts`,
                method: "POST",
                responseType: "json",
                data: {
                    lang_id: parseInt(languageSelected),
                    dist_id: parseInt(districtSelected)
                }
            });
            setData(response.data.data)
            setLoader(false);
        }
    }


    useEffect(() => {
        if (localStorage.getItem("role") === roles.ops) {
            getLanguages();
        }
    }, [])


    useEffect(() => {
        if (localStorage.getItem("role") === roles.ops) {
            getDistricts(1);
        }
    }, [])

    useEffect(() => {
        if (localStorage.getItem("role") === roles.ops) {
            getAdsAmounts(languageSelected, districtSelected);
        }
    }, [languageSelected, districtSelected])


    const changeLanguageHandler = (event) => {
        setLanguageSelected(event.target.value);
        getDistricts(event.target.value);
        setDistrictSelected("0")
    };

    const changeDistrictHandler = (event) => {
        setDistrictSelected(event.target.value);
    };

    const handleClose = () => {
        setShow(false);
        setSubmit(false);
        initialValues = JSON.parse(JSON.stringify(initialPrices));
        formik.setValues(initialValues);
    };

    function handleRequestClose(event) {
        if (event.detail.source === 'overlay') {
            event.preventDefault();
        }
    }

    const handleShow = (choose, item) => {
        if (choose === 'edit') {
            initialValues.ad_amount = item.ad_amount
            initialValues.premium_amount = item.premium_amount
            initialValues.location = (item.mandal_name === null) ? (item.dist_name) : (item.mandal_name)
            formik.setValues(initialValues);
            setShow(true)
        }
    };

    let formik = useFormik({
        initialValues: JSON.parse(JSON.stringify(initialPrices)),
        // validationSchema: ContactsSchema,
        onSubmit: async (values) => {
            if (flag === 'edit') {
                try {
                    let res = await api({

                        url: `/ads_price_location/updateAdsPrice`,
                        method: "PUT",
                        responseType: "json",
                        data: {
                            lang_id: langId,
                            dist_id: distId,
                            mandal_id: mandalId,
                            values
                        }
                    });
                    if (res?.data?.code === 500) {
                        Toast('error', res.data.message);
                        handleClose()
                        getAdsAmounts(languageSelected, districtSelected);
                        // loadData(search, currentPage);
                        values.ad_amount = '';
                        values.premium_amount = '';
                        values.location = ''
                    } else {
                        Toast("success", "Ads Price updated Successfully");
                        handleClose();
                        getAdsAmounts(languageSelected, districtSelected)
                        // loadData(search, currentPage);
                        values.ad_amount = '';
                        values.premium_amount = '';
                        values.location = ''
                    }

                } catch (error) {
                    let er = error?.response?.message || "Something went wrong"
                    Toast("error", er)
                    if (error.response.status === 401)
                        navigate("/")
                }
            }
        }
    });

    return (
        <>
            <div className="card-body cc-body">
                <div className="cc-padding">

                    <div className="flex items-center mb-3">

                        {/* <aside className="flex items-center gap-3 ml-auto"> */}
                        <div>
                            <SlSelect
                                size="medium"
                                placeholder="Select Language"
                                onSlChange={changeLanguageHandler}
                                value={languageSelected}
                            >
                                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                {languages.map(item => (
                                    <SlOption key={item.lang_id} value={item.lang_id}>
                                        {item.lang_name}
                                    </SlOption>
                                ))}

                            </SlSelect>
                        </div>

                        <div>
                            <SlSelect
                                size="medium"
                                placeholder="Select District"
                                onSlChange={changeDistrictHandler}
                                value={districtSelected}
                            >
                                <SlIcon library="lucide" name="pin-map" slot="prefix"></SlIcon>
                                <SlOption key={0} value="0">
                                    {"All"}
                                </SlOption>
                                {districts.map(item => (
                                    <SlOption key={item.dist_id} value={item.dist_id}>
                                        {item.dist_name}
                                    </SlOption>
                                ))}

                            </SlSelect>
                        </div>

                        {/* </aside > */}
                    </div >

                    <SlDrawer label="Update Ads Price" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
                        <form onSubmit={formik.handleSubmit}>
                            <div className="mb-3" >
                                <label className="mb-1">Location</label>
                                <input
                                    type='text'
                                    className="form-control"
                                    placeholder='Enter Location'
                                    name='location'
                                    disabled={flag === "edit" ? true : false}
                                    aria-label=""
                                    value={formik.values.location}
                                    onBlur={formik.handleBlur}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                    }}
                                />
                                {submit && formik.errors.location ? (
                                    <div className="text-red-600">{formik.errors.location}</div>
                                ) : null}
                            </div>
                            <div className="mb-3" >
                                <label className="mb-1">Normal Ad Price</label>
                                <input
                                    type='number'
                                    className="form-control"
                                    placeholder='Enter Ad Price'
                                    name='ad_amount'
                                    aria-label=""
                                    value={formik.values.ad_amount}
                                    onBlur={formik.handleBlur}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                    }}
                                />
                                {submit && formik.errors.ad_amount ? (
                                    <div className="text-red-600">{formik.errors.ad_amount}</div>
                                ) : null}
                            </div>
                            <div className="mb-3" >
                                <label className="mb-1">Premium Ad Price</label>
                                <input
                                    type='number'
                                    className="form-control"
                                    placeholder='Enter Premium Ad Price'
                                    name='premium_amount'
                                    aria-label=""
                                    value={formik.values.premium_amount}
                                    onBlur={formik.handleBlur}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                    }}
                                />
                                {submit && formik.errors.premium_amount ? (
                                    <div className="text-red-600">{formik.errors.premium_amount}</div>
                                ) : null}
                            </div>
                            <div slot="footer">
                                <SlButton
                                    type="submit"
                                    variant="primary"
                                    size="small"
                                    onClick={(e) => setSubmit(true)}>Update</SlButton>
                            </div>

                        </form>
                    </SlDrawer>

                    <div className="overflow-x-auto mb-4" >
                        <ScrollContainer>

                            < div className=' mb-4' >
                                <table className='table table-bordered'>
                                    <thead className="sticky top-0 ">
                                        <tr>
                                            <th >Location</th>
                                            <th>District Name</th>
                                            <th >Normal Ad Price</th>
                                            <th>Premium Ad Price</th>
                                            <th>Edit Price</th>
                                        </tr>
                                    </thead>
                                    {(data?.length && !loader) ? (
                                        <tbody>
                                            {data.map((item) => {
                                                return (
                                                    < tr key={item.dist_id} className="group/details hover:bg-slate-100" >
                                                        <th scope='row' >{(item.mandal_name === null) ? (item.dist_name) : (item.mandal_name)}</th>
                                                        <td>{item.dist_name}</td>
                                                        <td>{item.ad_amount || '-'}</td>
                                                        <td>{item.premium_amount || "-"}</td>
                                                        <td> {(localStorage.getItem("role") === roles.ops) ? (
                                                            <sl-tooltip content="Edit">
                                                                <sl-icon-button
                                                                    library="lucide"
                                                                    name="edit"
                                                                    onClick={async () => {
                                                                        setFlag("edit");
                                                                        handleShow('edit', item)
                                                                        if (item.lang_id) setLangId(item.lang_id);
                                                                        if (item.dist_id) setDistId(item.dist_id);
                                                                        if (item.mandal_id) setMandalId(item.mandal_id);
                                                                    }}
                                                                ></sl-icon-button>
                                                            </sl-tooltip>) : null}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>) : ((!data?.length && !loader)
                                            ? <NoDataFound colspan="8" />
                                            : <TableLoader colspan="8" />
                                    )
                                    }
                                </table>
                            </div >

                        </ScrollContainer>
                    </div>
                </div >
            </div >
        </>
    )

}

export default AdsPrices;